export const DATA_ACCESS_PATHS = {
  base: '/Data-Access',
  apiTokens: '/Data-Access/api-tokens',
  dataLake: '/Data-Access/data-lake',
  restApi: '/Data-Access/rest-api',
  mcpServer: '/Data-Access/mcp-server',
} as const;
